// 0 and -1 - refused (may depend on browser)
// 408 - timeout from web server
// 429 - too many requests
// 502 - nginx unavailable
// 503 - Microsoft IIS unavailable

export const NetworkErrorStatuses = [0, -1, 408, 429, 502, 503];
